import * as yup from 'yup';
import { createCompanyFormFields } from '../../fields/formFields/createCompany';
import { emailSchema } from '../common/emailSchema';
import { phoneSchema } from '../common/phoneSchema';

export const createCompanySchema = yup.object({
  [createCompanyFormFields.name]: yup
    .string()
    .min(3, 'Name must be at least 3 characters')
    .max(150, 'Name must be at most 150 characters')
    .required('Name is required')
    .trim(),
  [createCompanyFormFields.nameAr]: yup
    .string()
    .min(3, 'Arabic name must be at least 3 characters')
    .max(150, 'Arabic name must be at most 150 characters')
    .required('Arabic name is required')
    .trim(),
  [createCompanyFormFields.owner]: yup
    .string()
    .min(3, 'Owner name must be at least 3 characters')
    .max(150, 'Owner name must be at most 150 characters')
    .required('Owner is required')
    .trim(),
  [createCompanyFormFields.email]: emailSchema,
  [createCompanyFormFields.phoneNumber]: phoneSchema,
  [createCompanyFormFields.crNumber]: yup
    .string()
    .matches(/^[0-9]{10}$/, 'CR Number must be exactly 10 digits')
    .required('CR Number is required'),
  [createCompanyFormFields.vatNumber]: yup
    .string()
    .matches(/^[0-9]{15}$/, 'VAT must be a 15 digit number')
    .required('VAT is required'),
  [createCompanyFormFields.crExpDate]: yup
    .date()
    .typeError('Expiration Date must be a valid date')
    .required('Expiration Date is required')
    .min(new Date(new Date().setHours(0, 0, 0, 0)), 'Expiration Date cannot be in the past'),
});
